<script setup lang="ts">
    // eslint-disable-next-line no-unused-vars
    const props = defineProps(['pagingData'])
    // eslint-disable-next-line no-unused-vars
    const emits = defineEmits(['goToPage'])
</script>

<template>
  <div class="paging-bar">
    <button
      v-for="(numberOfPage, index) in pagingData?.pagesCount"
      v-if="pagingData?.pagesCount>1"
      :key="index"
      :class=" { active: index == pagingData.currentPage }"
      @click="$emit('goToPage', index)"
    >
      {{ index + 1 }}
    </button>
  </div>
</template>

<style scoped lang="less">
    .paging-bar {
        button {
            padding: 0 10px;
            background-color: transparent;
            min-height: 32px;
            min-width: 32px;
            border-width: 1px;
        }

        button:hover {
            background-color: #DDDDDD;
        }

        button.active {
            background-color: #bbbbbb;
        }

        button.active:hover {
            background-color: #999999;
        }

        button:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }

        button:last-child {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
</style>